import React, { useCallback } from 'react';
import Button from './Button';
import { Icon } from './Icon';
import { openInMaps } from '../../../utils/eventSorting';
import { useAnalytics } from '../../../contexts/AnalyticsContext';
import { Event } from '../../../types/event.types';

interface DirectionsButtonProps {
  latitude: number;
  longitude: number;
  locationName: string;
  /** Event object for analytics tracking */
  event?: Event;
  /** Context where the button is used (for analytics) */
  analyticsContext?: 'card' | 'carte' | 'modale' | 'carte_preview';
  /** Button variant */
  variant?: 'glass' | 'ghost' | 'primary' | 'secondary';
  /** Icon size */
  iconSize?: number;
  className?: string;
}

const DirectionsButton: React.FC<DirectionsButtonProps> = ({
  latitude,
  longitude,
  locationName,
  event,
  analyticsContext = 'card',
  variant = 'glass',
  iconSize = 20,
  className
}) => {
  const analytics = useAnalytics();

  const handleClick = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();

    // Track analytics if event is provided
    if (event) {
      analytics.trackNavigation(event, 'directions', analyticsContext);
    }

    openInMaps(latitude, longitude, locationName);
  }, [latitude, longitude, locationName, event, analytics, analyticsContext]);

  return (
    <Button
      variant={variant}
      onClick={handleClick}
      aria-label="Get directions"
      className={className}
    >
      <Icon name="Navigation" size={iconSize} />
    </Button>
  );
};

export default React.memo(DirectionsButton);
